import { jsx, jsxs } from "react/jsx-runtime";
import classnames from "classnames";
import { useRef } from "react";
import InnerRadio from "../../InnerRadio.js";
import "./index.css";
const rootClass = 'weet-components-radio-card';
function Card(props) {
    const { desc, children, checked, disabled, className, style, value, onChange, ...rest } = props;
    const innerRadioRef = useRef(null);
    const triggerOnChange = (e)=>{
        onChange?.({
            stopPropagation: e.stopPropagation,
            preventDefault: e.preventDefault,
            nativeEvent: innerRadioRef.current,
            target: {
                value,
                checked: true
            }
        });
    };
    return /*#__PURE__*/ jsxs("div", {
        onClick: triggerOnChange,
        style: style,
        className: classnames(className, rootClass, {
            checked: checked,
            disabled: disabled
        }),
        children: [
            /*#__PURE__*/ jsx(InnerRadio, {
                ...rest,
                checked: checked,
                ref: innerRadioRef,
                disabled: disabled,
                value: value,
                onChange: onChange
            }),
            /*#__PURE__*/ jsxs("div", {
                className: `${rootClass}__content`,
                children: [
                    /*#__PURE__*/ jsx("div", {
                        className: `${rootClass}__content-title`,
                        children: children
                    }),
                    /*#__PURE__*/ jsx("div", {
                        className: `${rootClass}__content-desc`,
                        children: desc
                    })
                ]
            })
        ]
    });
}
export { Card as default, rootClass };
